import { type SpecActionsType, SPECS_SET_SPECS, SPECS_INVALIDATE_SPECS } from "../actions/SpecActions";
import type { SortedSpecType } from "../../../../../common-deprecated/types/SpecTypes";
import type { ExtraType } from "../../../../../common-deprecated/types/CommonTypes";

export type SpecStateType = {
    techSpecs: SortedSpecType[];
    standardEquipment: ExtraType[];
    fetched: boolean;
};

export const initialState: SpecStateType = {
    techSpecs: [],
    standardEquipment: [],
    fetched: false,
};

export default (state: SpecStateType = initialState, action: SpecActionsType): SpecStateType => {
    switch (action.type) {
        case SPECS_SET_SPECS:
            return {
                ...state,
                techSpecs: action.techSpecs,
                standardEquipment: action.standardEquipment,
                fetched: true,
            };

        case SPECS_INVALIDATE_SPECS:
            return {
                ...state,
                fetched: false,
            };

        default:
            return state;
    }
};
